import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AppCommonModule } from '../app-common/app-common.module';
import { DatePickerDateAdapter } from '../app-common/adapters/date-picker-date-adapter';
import { DateAdapter } from '@angular/material/core';
import { SharedModule } from '../shared/shared.module';
import { SearchOrdersComponent } from './search-orders/search-orders.component';
import { ClinicalFeedbackComponent } from './clinical-feedback.component';
import { NewClinicalFeedbackComponent } from './new-clinical-feedback/new-clinical-feedback.component';
import { ClinicalFeedbackTableComponent } from './clinical-feedback-table/clinical-feedback-table.component';
import { PatientDetailsFormComponent } from './new-clinical-feedback/sections/patient-details-form/patient-details-form.component';
import { FeedbackFormComponent } from './new-clinical-feedback/sections/feedback-form/feedback-form.component';
import { AdvisedSeriousIncidentFormComponent } from './new-clinical-feedback/sections/advised-serious-incident-form/advised-serious-incident-form.component';
import { AddendumFormComponent } from './new-clinical-feedback/sections/addendum-form/addendum-form.component';
import { ContactDetailFormComponent } from './new-clinical-feedback/sections/contact-detail-form/contact-detail-form.component';
import { ConfirmedSeriousIncidentFormComponent } from './new-clinical-feedback/sections/advised-serious-incident-form/confirmed-serious-incident-form/confirmed-serious-incident-form.component';
import { DutyOfCandourFormComponent } from './new-clinical-feedback/sections/advised-serious-incident-form/duty-of-candour-form/duty-of-candour-form.component';
import { RegulatoryInvestigationsFormComponent } from './new-clinical-feedback/sections/advised-serious-incident-form/regulatory-investigations-form/regulatory-investigations-form.component';
import { OtherFormComponent } from './new-clinical-feedback/sections/advised-serious-incident-form/other-form/other-form.component';
import { QuillModule } from 'ngx-quill';
import { YesNoComponent } from './components/yes-no/yes-no.component';
import { RichTextEditorComponent } from './components/rich-text-editor/rich-text-editor.component';
import { TextComponent } from './components/text/text.component';
import { SearchTextComponent } from './components/search-text/search-text.component';
import { ValidationErrorComponent } from './components/validation-error/validation-error.component';
import { DateComponent } from './components/date/date.component';
import { FileUploadComponent } from './components/file-upload/file-upload.component';
import { CaptureDetailsComponent } from './components/capture-details/capture-details.component';
import { ContactPersonComponent } from './components/contact-person/contact-person.component';
import { DropdownComponent } from './components/dropdown/dropdown.component';
import { AttachmentsFormComponent } from './new-clinical-feedback/sections/attachments-form/attachments-form.component';
import { MatRichTextEditorComponent } from '../shared/mat-rich-text-editor/mat-rich-text-editor.component';
import { NgxMatSelectSearchModule } from 'ngx-mat-select-search';

@NgModule({
    declarations: [
        ClinicalFeedbackComponent,
        SearchOrdersComponent,
        ClinicalFeedbackTableComponent,
        NewClinicalFeedbackComponent,
        PatientDetailsFormComponent,
        FeedbackFormComponent,
        AdvisedSeriousIncidentFormComponent,
        AddendumFormComponent,
        AttachmentsFormComponent,
        ContactDetailFormComponent,
        ConfirmedSeriousIncidentFormComponent,
        DutyOfCandourFormComponent,
        RegulatoryInvestigationsFormComponent,
        OtherFormComponent,
        FileUploadComponent,
        YesNoComponent,
        RichTextEditorComponent,
        MatRichTextEditorComponent,
        TextComponent,
        SearchTextComponent,
        ValidationErrorComponent,
        DateComponent,
        CaptureDetailsComponent,
        ContactPersonComponent,
        DropdownComponent
    ],
    imports: [CommonModule, NgxMatSelectSearchModule, AppCommonModule, SharedModule, QuillModule.forRoot()],
    exports: [ClinicalFeedbackComponent],
    providers: [{ provide: DateAdapter, useClass: DatePickerDateAdapter }],
    schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class ClinicalFeedbackModule {}
